<ng-template #content let-c="close" let-d="dismiss">
   
    <div class="modal-header">
        <h6 class="modal-title" *ngIf="_Module == 1"><span translate>TITLE.TITLE_GSR_AUDIT</span> ({{ComplainModel.DisplayCallNo}} |  {{ComplainModel.RequestedByGuestName}})</h6>
        <h6 class="modal-title" *ngIf="_Module != 1"><span translate>TITLE.TITLE_GSR_AUDIT_GLITCH</span> ({{ComplainModel.GlitchCallNo}} | {{ComplainModel.GuestInfo.FullName}})</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
        <div class="row form-group">
            <div class="col-auto" *ngIf="_Module == 1"><label translate>LBL.CALL_DESC</label></div>
            <div class="col-auto" *ngIf="_Module != 1"><label translate>LBL.GLITCH_DESC</label></div>
            <div class="col-auto">{{_Module == 1 ? ComplainModel.CallDescription : ComplainModel.Description}}</div>
        </div>
        <div class="row form-group">
            <div class="col-6"><label class="col-form-label" translate>LBL.QUESTIONS</label></div>
            <div class="col justify-content-between d-flex">
                <label translate>LBL.LOW</label>
                <label translate>LBL.HIGH</label>
            </div>
        </div>
        <div class="row form-group" *ngFor="let row of Model; let index = index">
            <div class="col-6" [ngClass]="(row.IsCompulsory == true ? 'req' : '')">{{row.Question}}</div>
            <div class="col justify-content-between d-flex">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" [value]="1" id="gsr_Rating_one_{{row.QuestionId}}_1" name="rating_{{row.QuestionId}}" [(ngModel)]="RequestModel.ListGSRRating[index].Rating" />
                    <label class="custom-control-label" for="gsr_Rating_one_{{row.QuestionId}}_1">1</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" [value]="2" id="gsr_Rating_two_{{row.QuestionId}}_2" name="rating_{{row.QuestionId}}" [(ngModel)]="RequestModel.ListGSRRating[index].Rating" />
                    <label class="custom-control-label" for="gsr_Rating_two_{{row.QuestionId}}_2">2</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" [value]="3" id="gsr_Rating_three_{{row.QuestionId}}_3" name="rating_{{row.QuestionId}}" [(ngModel)]="RequestModel.ListGSRRating[index].Rating" />
                    <label class="custom-control-label" for="gsr_Rating_three_{{row.QuestionId}}_3">3</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" [value]="4" id="gsr_Rating_four_{{row.QuestionId}}_4" name="rating_{{row.QuestionId}}" [(ngModel)]="RequestModel.ListGSRRating[index].Rating" />
                    <label class="custom-control-label" for="gsr_Rating_four_{{row.QuestionId}}_4">4</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" [value]="5" id="gsr_Rating_five_{{row.QuestionId}}_5" name="rating_{{row.QuestionId}}" [(ngModel)]="RequestModel.ListGSRRating[index].Rating" />
                    <label class="custom-control-label" for="gsr_Rating_five_{{row.QuestionId}}_5">5</label>
                </div>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-auto"><label translate>LBL.GUEST_REMARKS</label></div>
            <div class="col">
                <textarea class="rounded col" placeholder="" [(ngModel)]="RequestModel.GuestRemarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}"></textarea>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" type="submit" (click)="onSubmit()" translate>BTN.BTN_OK</button>
        <button class="btn btn-secondary" type="button" (click)="c('')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>
